import { render, staticRenderFns } from "./organManage.vue?vue&type=template&id=592ee654&scoped=true"
import script from "./organManage.vue?vue&type=script&lang=js"
export * from "./organManage.vue?vue&type=script&lang=js"
import style0 from "./organManage.vue?vue&type=style&index=0&id=592ee654&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592ee654",
  null
  
)

export default component.exports